module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"PayPal Checkout":"PayPal Checkout","Webhook ID":"Webhook ID"}}')
  delete Component.options._Ctor
}
